<template>
  <div>
    <NBar :title="timeSelect === -1 ? '收益情况' : timeList[timeSelect].value + '收益情况'"/>
    <div class="top">
      <nut-scroller class="time-more">
        <div slot="list" @click="timeItemClick(index)"
             :style="{backgroundColor:timeSelect === item.label ? '#ffffff' : '#e9e9e9',
             border:timeSelect === item.label ? '1px solid #194fff' : '1px solid #e9e9e9',
             color:timeSelect === item.label ? '#194fff' : '#a1a5ab'}"
             class="time-item" v-for="(item ,index) in timeList" :key="index">{{ item.value }}
        </div>
      </nut-scroller>
      <nut-cell title="时间" :desc="date[0]+'至'+date[1]" :show-icon="true" @click.native="isCalendar = true"/>
      <nut-calendar :is-visible.sync="isCalendar" :default-value="date" type="range" :start-date="null"
                    :end-date="$util.formatDate.format(new Date(),'yyyy-MM-dd')"
                    @close="switchPickerClose('isCalendar')" @choose="setChooseValue">
      </nut-calendar>
    </div>
    <div style="height: 40px;line-height: 40px;display: flex;">
      <span style="width: 30%;margin-left:30px;">收益构成</span>
      <span style="width: 70%;margin-left:10px;">收益</span>
    </div>
    <div class="item-div" style="background-color: #1DA437;" @click="onlineItem(0)">
      <div style="display: flex;">
        <span style="width: 30%;margin-left:30px;"></span>
        <nut-price :price="data.wxPayMoney" style="width: 70%;zoom: 1.2;" :decimalDigits="2" :needSymbol="true"
                   :thousands="true"/>
      </div>
      <div style="display: flex;align-items: center;justify-content: space-between;">
        <div style="margin-left: 20px;font-size: 16px;">微信支付</div>
        <div style="width: 65%;height: 1px;background-color: #21b43d;"></div>
        <img :src="require('../../../resource/img/device/arrow-right.png')" style="width: 25px;height: 25px;">
      </div>
      <div style="display: flex;">
        <span style="width: 30%;margin-left:30px;"></span>
        <div style="width: 65%;display: flex;">
          <div style="flex: 1;display: flex; flex-direction: column;">
            <span>单笔价格</span>
            <nut-price :price="data.wxOrderNum > 0 ? (data.wxPayMoney/data.wxOrderNum) : 0"
                       style="width: 70%;zoom: 0.9;" :decimalDigits="2"
                       :needSymbol="true" :thousands="true"/>
          </div>
          <div style="flex: 1;display: flex; flex-direction: column;">
            <span>交易笔数</span>
            <span>{{ data.wxOrderNum }}笔</span>
          </div>
        </div>
      </div>
    </div>
    <div class="item-div" @click="onlineItem(1)">
      <div style="display: flex;">
        <span style="width: 30%;margin-left:30px;"></span>
        <nut-price :price="data.balancePayMoney" style="width: 70%;zoom: 1.2;" :decimalDigits="2" :needSymbol="true"
                   :thousands="true"/>
      </div>
      <div style="display: flex;align-items: center;justify-content: space-between;">
        <div style="margin-left: 20px;font-size: 16px;">余额支付</div>
        <div style="width: 65%;height: 1px;background-color: #7a9aff;"></div>
        <img :src="require('../../../resource/img/device/arrow-right.png')" style="width: 25px;height: 25px;">
      </div>
      <div style="display: flex;">
        <span style="width: 30%;margin-left:30px;"></span>
        <div style="width: 65%;display: flex;">
          <div style="flex: 1;display: flex; flex-direction: column;">
            <span>单笔价格</span>
            <nut-price :price="data.balanceOrderNum > 0 ? (data.balancePayMoney/data.balanceOrderNum) : 0"
                       style="width: 70%;zoom: 0.9;" :decimalDigits="2"
                       :needSymbol="true" :thousands="true"/>
          </div>
          <div style="flex: 1;display: flex; flex-direction: column;">
            <span>交易笔数</span>
            <span>{{ data.balanceOrderNum }}笔</span>
          </div>
        </div>
      </div>
    </div>
    <div class="item-div" style="background-color: #FC7F00;" @click="onlineItem(2)">
      <div style="display: flex;">
        <span style="width: 30%;margin-left:30px;"></span>
        <nut-price :price="data.rechargePayMoney" style="width: 70%;zoom: 1.2;" :decimalDigits="2" :needSymbol="true"
                   :thousands="true"/>
      </div>
      <div style="display: flex;align-items: center;justify-content: space-between;">
        <div style="margin-left: 20px;font-size: 16px;">充值支付</div>
        <div style="width: 65%;height: 1px;background-color: #ffa44d;"></div>
        <img :src="require('../../../resource/img/device/arrow-right.png')" style="width: 25px;height: 25px;">
      </div>
      <div style="display: flex;">
        <span style="width: 30%;margin-left:30px;"></span>
        <div style="width: 65%;display: flex;">
          <div style="flex: 1;display: flex; flex-direction: column;">
            <span>单笔价格</span>
            <nut-price :price="data.rechargeOrderNum > 0 ? (data.rechargePayMoney/data.rechargeOrderNum) : 0"
                       style="width: 70%;zoom: 0.9;" :decimalDigits="2"
                       :needSymbol="true" :thousands="true"/>
          </div>
          <div style="flex: 1;display: flex; flex-direction: column;">
            <span>交易笔数</span>
            <span>{{ data.rechargeOrderNum }}笔</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 收益
 */
export default {
  name: 'Earnings',
  props: ['startTime', 'endTime'],
  data() {
    return {
      //当前选择时间索引
      timeSelect: 0,
      timeList: [
        {
          label: 0,
          value: '今天'
        }, {
          label: 1,
          value: '昨天'
        }, {
          label: 2,
          value: '本周'
        }, {
          label: 3,
          value: '本月'
        }, {
          label: 4,
          value: '半年'
        }],
      //时间选择器区间
      date: [],
      //是否显示时间选择器
      isCalendar: false,
      data: {}
    }
  },
  beforeRouteEnter(to,from,next){
    let name  = from.name
    next(vm=>{
      if (name === "DeviceHome"){
        vm.timeItemClick(0)
      }
    })
  },
  created() {
    this.date = [this.$util.formatDate.format (new Date (), 'yyyy-MM-dd'), this.$util.formatDate.format (new Date (), 'yyyy-MM-dd')]
  },
  activated() {
    this.getData ()
  },
  methods: {
    getData() {
      let data0 = this.date[0].replace (/-/g, '/')
      let data1 = this.date[1].replace (/-/g, '/')
      let time1 = new Date (data0 + ' 00:00:00')
      let time2 = new Date (data1 + ' 23:59:59')
      let data = {
        startTime: time1.getTime () / 1000,
        endTime: time2.getTime () / 1000
      }
      if (!this.$util.isArrOrNull (this.$api.merId)) {
        data.merId = this.$api.merId
      }
      if (!this.$util.isArrOrNull (this.$api.user.merIds)) {
        data.merIds = this.$api.user.merIds
      }
      this.$api.post ({
        url: '/device/api/device/order/earnings/find',
        data: data,
        loading: false
      }).then (res => {
        this.data = res.data
      })
    },
    //日期快捷选择
    timeItemClick(index) {
      this.timeSelect = index
      let time1 = new Date ()
      let time2 = new Date ()
      let nowDayOfWeek = time1.getDay () //今天本周的第几天
      let nowDay = time1.getDate () //当前日
      let nowMonth = time1.getMonth () //当前月
      let nowYear = time1.getFullYear () //当前年
      switch (index) {
        case 0://今天
          this.date[0] = this.$util.formatDate.format (time1, 'yyyy-MM-dd')
          this.date[1] = this.$util.formatDate.format (time2, 'yyyy-MM-dd')
          break
        case 1://昨天
          time1.setDate (time1.getDate () - 1)
          time2.setDate (time2.getDate () - 1)
          this.date[0] = this.$util.formatDate.format (time1, 'yyyy-MM-dd')
          this.date[1] = this.$util.formatDate.format (time2, 'yyyy-MM-dd')
          break
        case 2://本周
          let weekStartDate = new Date (nowYear, nowMonth, nowDay - nowDayOfWeek)
          //let weekEndDate = new Date(nowYear, nowMonth, nowDay + (6 - nowDayOfWeek))
          this.date[0] = this.$util.formatDate.format (weekStartDate, 'yyyy-MM-dd')
          this.date[1] = this.$util.formatDate.format (time2, 'yyyy-MM-dd')
          break
        case 3://本月
          let monthStartDate = new Date (nowYear, nowMonth, 1)
          /*let monthEndDate = new Date(nowYear, nowMonth + 1, 1)
          let days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24)
          monthEndDate = new Date(nowYear, nowMonth, days)*/
          this.date[0] = this.$util.formatDate.format (monthStartDate, 'yyyy-MM-dd')
          this.date[1] = this.$util.formatDate.format (time2, 'yyyy-MM-dd')
          break
        case 4://半年
          let monthTime = new Date (nowYear, nowMonth - 6, 1)
          this.date[0] = this.$util.formatDate.format (monthTime, 'yyyy-MM-dd')
          this.date[1] = this.$util.formatDate.format (time2, 'yyyy-MM-dd')
          break
      }
      this.getData ()
    },
    switchPickerClose(param) {
      this[`${param}`] = false
    },
    setChooseValue(param) {
      this.date = [...[param[0][3], param[1][3]]]
      this.isCalendar = false
      this.timeSelect = -1
      this.getData ()
    },
    onlineItem(tab) {
      this.$router.push (`/device/EarningsDetail?startTime=${this.date[0]}&endTime=${this.date[1]}&tab=${tab}`)
    }
  }
}
</script>

<style scoped>
>>> .curr {
  color: #1a87ff;
}

>>> .nut-calendar-control .nut-calendar-cancel-btn, >>> .nut-calendar-control .nut-calendar-confirm-btn {
  color: #1a87ff;
}

>>> .nut-calendar-control .nut-calendar-week span:first-child, >>> .nut-calendar-control .nut-calendar-week span:last-child {
  color: #1a87ff;
}

>>> .nut-calendar-months .nut-calendar-month-con .nut-calendar-month-day-active {
  background-color: #1a87ff;
}

>>> .nut-calendar-months .nut-calendar-month-con .nut-calendar-month-day-choose {
  background-color: #abd1ff;
}

.top {
  display: flex;
  flex-direction: column;
  background-color: white;
}

.top .time-more {
  margin: 10px 0;
}

.top .time-more .time-item {
  font-size: 14px;
  background-color: #e9e9e9;
  border: 1px solid #e9e9e9;
  color: #a1a5ab;
  border-radius: 5px;
  width: 50px;
  text-align: center;
  padding: 6px 0;
  margin-left: 10px;
}

.item-div {
  color: white;
  display: flex;
  padding: 20px 0;
  flex-direction: column;
  justify-content: center;
  margin: 10px;
  border-radius: 5px;
  background-color: #1a87ff;
}
</style>



// WEBPACK FOOTER //
// src/components/device/home/Earnings.vue